// extracted by mini-css-extract-plugin
export default {"blockContainer":"block_blockContainer__y5Xw+","belowSpace":"block_belowSpace__tQOTP"};